import React, { PropsWithChildren } from 'react';

import { autoUpdate, offset, useFloating, FloatingPortal, FloatingOverlay } from '@floating-ui/react';
import cx from 'classnames';

import s from './index.module.css';
import * as t from './types';

export const usePopover = (props: t.UsePopoverProps) => {
  const { options } = props;

  const [isOpen, setIsOpen] = React.useState(false);
  const { refs, floatingStyles } = useFloating({
    open: isOpen,
    ...options,
    middleware: [offset(6), ...(options?.middleware || [])],
    whileElementsMounted: autoUpdate,
  });

  const Popover = ({ children }: PropsWithChildren<{}>) => {
    if (!isOpen) return null;

    return (
      <FloatingPortal>
        <FloatingOverlay onClick={() => setIsOpen(false)} className={s.tooltipOverlay} />
        <div
          ref={refs.setFloating}
          style={{ ...floatingStyles }}
          className={cx(s.tooltipFloating, props.containerClassName)}
        >
          <div className={cx(props.tooltipWrapperClass)}>{children}</div>
        </div>
      </FloatingPortal>
    );
  };

  return {
    isOpen,
    toggleTooltip: () => setIsOpen((p) => !p),
    openTooltip: () => setIsOpen(true),
    closeTooltip: () => setIsOpen(false),
    setReference: refs.setReference,
    Popover,
  };
};
